import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mtqatiznkmzzshvphzvf.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10cWF0aXpua216enNodnBoenZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwNzU0MTUsImV4cCI6MjA4ODY1MTQxNX0.9eUyuIJDLkQMPuNomRGN9EoomG7DkINXtsU7v1AwKOo'

const DB_NAME  = 'toto-idb';
const DB_STORE = 'auth';

let _dbp;
function getDB() {
  if (!_dbp) _dbp = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = e => e.target.result.createObjectStore(DB_STORE);
    req.onsuccess       = e => resolve(e.target.result);
    req.onerror         = e => reject(e.target.error);
  });
  return _dbp;
}

const idbStorage = {
  async getItem(key) {
    const db = await getDB();
    return new Promise((resolve, reject) => {
      const req = db.transaction(DB_STORE, 'readonly').objectStore(DB_STORE).get(key);
      req.onsuccess = () => resolve(req.result ?? null);
      req.onerror   = () => reject(req.error);
    });
  },
  async setItem(key, value) {
    const db = await getDB();
    return new Promise((resolve, reject) => {
      const req = db.transaction(DB_STORE, 'readwrite').objectStore(DB_STORE).put(value, key);
      req.onsuccess = () => resolve();
      req.onerror   = () => reject(req.error);
    });
  },
  async removeItem(key) {
    const db = await getDB();
    return new Promise((resolve, reject) => {
      const req = db.transaction(DB_STORE, 'readwrite').objectStore(DB_STORE).delete(key);
      req.onsuccess = () => resolve();
      req.onerror   = () => reject(req.error);
    });
  },
};

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'toto-auth',
    storage: idbStorage,
  }
})
